import React from 'react'
import styles from "./brand.module.scss"

class Brand extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			hovered:  false
		}
	}

	toggleActiveState(newState) {
		this.setState(prevState => ({
				hovered: !prevState.hovered
			})
		)
	}

	render () {
		const brand = this.props.brand;
		const overlayStyle = {
			backgroundColor: brand.color		
		}
		
		const brandClass = this.state.hovered ? `${styles.brand} ${styles.active}` : `${styles.brand}`
		return (
			<div className={brandClass} 
				onClick={this.toggleActiveState.bind(this)}		
			>
				<div className={styles.brandInner}>
					<img className={styles.brandImage} src={require(`../../img/screen-${brand.imageName}.jpg`)} alt={brand.name} />
					
					<div className={styles.brandOverlay} style={overlayStyle}>
						<img className={styles.logoImage} src={require(`../../img/logo-${brand.imageName}.png`)} alt={brand.name} />
					</div>
				</div>
			</div>
		)
	}
}

export default Brand



// WEBPACK FOOTER //
// ./src/components/Brand/Brand.js